import React from 'react';
import { Content } from './shared';

const AetnaTherapeuticMassage = () => (
  <Content>
    Learn more about discounts on massage therapy visits on the Aetna website.
    <ol>
      <li>Log into your ChooseHealthy account.</li>

      <li>Go to Therapeutic Massage {'>'} Find a Provider.</li>

      <li>Make an appointment for a visit. Don't forget your Aetna card!</li>
    </ol>
  </Content>
);

export default AetnaTherapeuticMassage;
